
export default {

	'атлетичное': {
		'до 20 мин.': {
			'миниатюрный': {
				'щенки': {
					food: {
						29: 'от 15 до 113 граммов корма в день.',
						33: 'от 15 до 113 граммов корма в день.',
						51: 'от 2 до 3 упаковок в день.',
					},
					actions: [
						'ball',
						'toy-squeaky',
					],
				},
				'взрослые': {
					food: {
						34: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 5 упаковок в день.',
						53: 'от 2 до 5 упаковок в день.',
						54: 'от 2 до 5 упаковок в день.',
						38: 'от 25 до 80 граммов корма в день.',
					},
					actions: [
						'rope',
						'training-trick',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 3 упаковок в день.',
						53: 'от 2 до 3 упаковок в день.',
						54: 'от 2 до 3 упаковок в день.',
					},
					actions: [
						'search-food',
						'ball',
					],
				},
			},
			'мелкий': {
				'щенки': {
					food: {
						30: 'от 14 до 204 граммов корма в день.',
						33: 'от 14 до 204 граммов корма в день.',
						51: 'от 4,5 до 6 упаковок в день.',
					},
					actions: [
						'toy-heavy',
						'catch-up',
					],
				},
				'взрослые': {
					food: {
						35: 'от 25 до 135 граммов корма в день.',
						52: 'от 3 до 6 упаковок в день.',
						53: 'от 3 до 6 упаковок в день.',
						54: 'от 3 до 6 упаковок в день.',
						38: 'от 25 до 135 граммов корма в день.',
					},
					actions: [
						'frisbee',
						'run-usual',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 135 граммов корма в день.',
						52: 'от 4 до 5 упаковок в день',
						53: 'от 4 до 5 упаковок в день',
						54: 'от 4 до 5 упаковок в день',
					},
					actions: [
						'toy-food',
						'rope',
					],
				},
			},
			'средний': {
				'щенки': {
					food: {
						31: 'от 80 до 374 граммов корма в день.',
						33: 'от 80 до 374 граммов корма в день.',
						51: 'от 7 до 9 упаковок в день.',
					},
					actions: [
						'training-game',
						'toy-heavy',
					],				
				},
				'взрослые': {
					food: {
						36: 'от 140 до 275 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',
						38: 'от 140 до 275 граммов корма в день.',
					},
					actions: [
						'frisbee',
						'training-trick',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 152 до 250 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',
					},
					actions: [
						'mixed',
						'ball',
					],
				},
			},
			'крупный': {
				'щенки': {
					food: {
						32: 'от 310 до 525 граммов корма в день.',
						33: 'от 310 до 525 граммов корма в день.',
						51: 'от 13 до 20 упаковок в день.',
					},
					actions: [
						'training-trick',
						'training-aport',
					],
				},
				'взрослые': {
					food: {
						37: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',
					},
					actions: [
						'training-discipline',
						'training-jump-over',
					],
				},
				'от 6 лет и выше': {
					food: {
						44: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',
					},
					actions: [
						'run-short',
						'search-food',
					],
				},
			},
		},
		'20-40 мин.': {
			'миниатюрный': {
				'щенки': {
					food: {
						29: 'от 15 до 113 граммов корма в день.',
						33: 'от 15 до 113 граммов корма в день.',
						51: 'от 2 до 3 упаковок в день.',
					},
					actions: [
						'toy-soft-puppy',
						'catch-up',
					],
				},
				'взрослые': {
					food: {
						34: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 5 упаковок в день',
						53: 'от 2 до 5 упаковок в день',
						54: 'от 2 до 5 упаковок в день',
						38: 'от 25 до 80 граммов корма в день',
					},
					actions: [
						'frisbee',
						'training-aport',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 3 упаковок в день.',
						53: 'от 2 до 3 упаковок в день.',
						54: 'от 2 до 3 упаковок в день.',
					},
					actions: [
						'toy-heavy',
						'search-toy',
					],
				},
			},
			'мелкий': {
				'щенки': {
					food: {
						30: 'от 14 до 204 граммов корма в день.',
						33: 'от 14 до 204 граммов корма в день.',
						51: 'от 4,5 до 6 упаковок в день',
					},
					actions: [
						'training-basic',
						'ball',
					],
				},
				'взрослые': {
					food: {
						35: 'от 25 до 135 граммов корма в день.',
						52: 'от 3 до 6 упаковок в день.',
						53: 'от 3 до 6 упаковок в день.',
						54: 'от 3 до 6 упаковок в день.',
						38: 'от 25 до 135 граммов корма в день.',
					},
					actions: [
						'frisbee',
						'training-jump',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 135 граммов корма в день.',
						52: 'от 4 до 5 упаковок в день.',
						53: 'от 4 до 5 упаковок в день.',
						54: 'от 4 до 5 упаковок в день.',
					},
					actions: [
						'search-food',
						'toy-soft-small',
					],
				},
			},
			'средний': {
				'щенки': {
					food: {
						31: 'от 80 до 374 граммов корма в день.',
						33: 'от 80 до 374 граммов корма в день.',
						51: 'от 7 до 9 упаковок в день.',
					},
					actions: [
						'training-pick',
						'catch-up',
					],
				},
				'взрослые': {
					food: {
						36: 'от 140 до 275 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',
						38: 'от 140 до 275 граммов корма в день.',
					},
					actions: [
						'run-widely',
						'rope',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 152 до 250 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',
					},
					actions: [
						'training-trick',
						'search-food',
					],
				},
			},
			'крупный': {
				'щенки': {
					food: {
						32: 'от 310 до 525 граммов корма в день.',
						33: 'от 310 до 525 граммов корма в день.',
						51: 'от 13 до 20 упаковок в день.',
					},
					actions: [
						'toy-heavy',
						'training-basic',
					],
				},
				'взрослые': {
					food: {
						37: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',
					},
					actions: [
						'velo',
						'training-jump-over',
					],
				},
				'от 6 лет и выше': {
					food: {
						44: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',
					},
					actions: [
						'search-toy',
						'rope',
					],
				},
			},
		},
		'40 мин. и более': {
			'миниатюрный': {
				'щенки': {
					food: {
						29: 'от 15 до 113 граммов корма в день.',
						33: 'от 15 до 113 граммов корма в день.',
						51: 'от 2 до 3 упаковок в день.',
					},
					actions: [
						'training-aport',
						'catch-up',
					],
				},
				'взрослые': {
					food: {
						34: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 5 упаковок в день.',
						53: 'от 2 до 5 упаковок в день.',
						54: 'от 2 до 5 упаковок в день.',
						38: 'от 25 до 80 граммов корма в день.',
					},
					actions: [
						'ball',
						'training-pick',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 3 упаковок в день.',
						53: 'от 2 до 3 упаковок в день.',
						54: 'от 2 до 3 упаковок в день.',
					},
					actions: [
						'walk-quiet',
						'toy-soft-small',
					],
				},
			},
			'мелкий': {
				'щенки': {
					food: {
						30: 'от 14 до 204 граммов корма в день.',
						33: 'от 14 до 204 граммов корма в день.',
						51: 'от 4,5 до 6 упаковок в день.',
					},
					actions: [
						'frisbee',
						'ball',
					],
				},
				'взрослые': {
					food: {
						35: 'от 25 до 135 граммов корма в день.',
						52: 'от 3 до 6 упаковок в день.',
						53: 'от 3 до 6 упаковок в день.',
						54: 'от 3 до 6 упаковок в день.',
						38: 'от 25 до 135 граммов корма в день.',
					},
					actions: [
						'search-owner',
						'training-trick',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 135 граммов корма в день.',
						52: 'от 4 до 5 упаковок в день.',
						53: 'от 4 до 5 упаковок в день.',
						54: 'от 4 до 5 упаковок в день.',
					},
					actions: [
						'rope',
						'training-discipline',
					],
				},
			},
			'средний': {
				'щенки': {
					food: {
						31: 'от 80 до 374 граммов корма в день.',
						33: 'от 80 до 374 граммов корма в день.',
						51: 'от 7 до 9 упаковок в день.',
					},
					actions: [
						'training-basic',
						'toy-squeaky',
					],
				},
				'взрослые': {
					food: {
						36: 'от 140 до 275 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',
						38: 'от 140 до 275 граммов корма в день.',
					},
					actions: [
						'training-basic',
						'rope',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 152 до 250 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',
					},
					actions: [
						'training-trick',
						'search-owner',
					],
				},
			},
			'крупный': {
				'щенки': {
					food: {
						32: 'от 310 до 525 граммов корма в день.',
						33: 'от 310 до 525 граммов корма в день.',
						51: 'от 13 до 20 упаковок в день.',
					},
					actions: [
						'rope',
						'catch-up',
					],
				},
				'взрослые': {
					food: {
						37: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',
					},
					actions: [
						'run-widely',
						'training-aport',
					],
				},
				'от 6 лет и выше': {
					food: {
						44: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',
					},
					actions: [
						'walk-quiet',
						'ball',
					],
				},
			},
		},
	},
	'рыхлое': {
		'до 20 мин.': {
			'миниатюрный': {
				'щенки': {
					food: {
						29: 'от 15 до 113 граммов корма в день.',
						33: 'от 15 до 113 граммов корма в день.',
						51: 'от 2 до 3 упаковок в день.',
					},
					actions: [
						'ball',
						'toy-soft-small',
					],
				},
				'взрослые': {
					food: {
						34: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 5 упаковок в день.',
						53: 'от 2 до 5 упаковок в день.',
						54: 'от 2 до 5 упаковок в день.',
						38: 'от 25 до 80 граммов корма в день.',
					},
					actions: [
						'walk-active',
						'toy-heavy',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 3 упаковок в день.',
						53: 'от 2 до 3 упаковок в день.',
						54: 'от 2 до 3 упаковок в день.',
					},
					actions: [
						'search-food',
						'toy-soft-small',
					],	
				},
			},
			'мелкий': {
				'щенки': {
					food: {
						30: 'от 14 до 204 граммов корма в день.',
						33: 'от 14 до 204 граммов корма в день.',
						51: 'от 4,5 до 6 упаковок в день.',
					},
					actions: [
						'training-basic',
						'rope',
					],
				},
				'взрослые': {
					food: {
						35: 'от 25 до 135 граммов корма в день.',
						52: 'от 3 до 6 упаковок в день.',
						53: 'от 3 до 6 упаковок в день.',
						54: 'от 3 до 6 упаковок в день.',
						38: 'от 25 до 135 граммов корма в день.',
					},
					actions: [
						'training-trick',
						'training-stranger',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 135 граммов корма в день.',
						52: 'от 4 до 5 упаковок в день.',
						53: 'от 4 до 5 упаковок в день.',
						54: 'от 4 до 5 упаковок в день.',
					},
					actions: [
						'training-discipline',
						'ball',
					],
				},
			},
			'средний': {
				'щенки': {
					food: {
						31: 'от 80 до 374 граммов корма в день.',
						33: 'от 80 до 374 граммов корма в день.',
						51: 'от 7 до 9 упаковок в день.',
					},
					actions: [
						'rope',
						'training-basic',
					],
				},
				'взрослые': {
					food: {
						36: 'от 140 до 275 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',
						38: 'от 140 до 275 граммов корма в день.',
					},
					actions: [
						'training-basic',
						'ball',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 152 до 250 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',
					},
					actions: [
						'training-trick',
						'toy-soft',
					],
				},
			},
			'крупный': {
				'щенки': {
					food: {
						32: 'от 310 до 525 граммов корма в день.',
						33: 'от 310 до 525 граммов корма в день.',
						51: 'от 13 до 20 упаковок в день.',
					},
					actions: [
						'training-pick',
						'search-owner',
					],
				},
				'взрослые': {
					food: {
						37: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',
					},
					actions: [
						'rope',
						'training-trick',
					],
				},
				'от 6 лет и выше': {
					food: {
						44: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',
					},
					actions: [
						'search-food',
						'ball',
					],
				},
			},
		},
		'20-40 мин.': {
			'миниатюрный': {
				'щенки': {
					food: {
						29: 'от 15 до 113 граммов корма в день.',
						33: 'от 15 до 113 граммов корма в день.',
						51: 'от 2 до 3 упаковок в день.',
					},
					actions: [
						'toy-heavy',
						'ball',
					],
				},
				'взрослые': {
					food: {
						34: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 5 упаковок в день.',
						53: 'от 2 до 5 упаковок в день.',
						54: 'от 2 до 5 упаковок в день.',
						38: 'от 25 до 80 граммов корма в день.',
					},
					actions: [
						'training-discipline',
						'rope',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 3 упаковок в день.',
						53: 'от 2 до 3 упаковок в день.',
						54: 'от 2 до 3 упаковок в день.',
					},
					actions: [
						'toy-soft-small',
						'training-trick',
					],
				},
			},
			'мелкий': {
				'щенки': {
					food: {
						30: 'от 14 до 204 граммов корма в день.',
						33: 'от 14 до 204 граммов корма в день.',
						51: 'от 4,5 до 6 упаковок в день.',
					},
					actions: [
						'rope',
						'training-basic',
					],
				},
				'взрослые': {
					food: {
						35: 'от 25 до 135 граммов корма в день.',
						52: 'от 3 до 6 упаковок в день.',
						53: 'от 3 до 6 упаковок в день.',
						54: 'от 3 до 6 упаковок в день.',
						38: 'от 25 до 135 граммов корма в день.',
					},
					actions: [
						'training-pick',
						'ball',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 135 граммов корма в день.',
						52: 'от 4 до 5 упаковок в день.',
						53: 'от 4 до 5 упаковок в день.',
						54: 'от 4 до 5 упаковок в день.',
					},
					actions: [
						'mixed',
						'search-food',
					],
				},
			},
			'средний': {
				'щенки': {
					food: {
						31: 'от 80 до 374 граммов корма в день.',
						33: 'от 80 до 374 граммов корма в день.',
						51: 'от 7 до 9 упаковок в день.',
					},
					actions: [
						'rope',
						'catch-up',
					],
				},
				'взрослые': {
					food: {
						36: 'от 140 до 275 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',
						38: 'от 140 до 275 граммов корма в день.',
					},
					actions: [
						'training-trick',
						'training-discipline',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 152 до 250 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',
					},
					actions: [
						'toy-squeaky',
						'toy-food',
					],
				},
			},
			'крупный': {
				'щенки': {
					food: {
						32: 'от 310 до 525 граммов корма в день.',
						33: 'от 310 до 525 граммов корма в день.',
						51: 'от 13 до 20 упаковок в день.',
					},
					actions: [
						'training-basic',
						'training-aport',
					],
				},
				'взрослые': {
					food: {
						37: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',
					},
					actions: [
						'frisbee',
						'run-usual',
					],
				},
				'от 6 лет и выше': {
					food: {
						44: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',
					},
					actions: [
						'training-trick',
						'search-toy',
					],
				},
			},
		},
		'40 мин. и более': {
			'миниатюрный': {
				'щенки': {
					food: {
						29: 'от 15 до 113 граммов корма в день.',
						33: 'от 15 до 113 граммов корма в день.',
						51: 'от 2 до 3 упаковок в день.',
					},
					actions: [
						'ball',
						'rope',
					],
				},
				'взрослые': {
					food: {
						34: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 5 упаковок в день.',
						53: 'от 2 до 5 упаковок в день.',
						54: 'от 2 до 5 упаковок в день.',
						38: 'от 25 до 80 граммов корма в день.',
					},
					actions: [
						'toy-soft-small',
						'training-trick',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 3 упаковок в день.',
						53: 'от 2 до 3 упаковок в день.',
						54: 'от 2 до 3 упаковок в день.',
					},
					actions: [
						'search-food',
						'toy-squeaky',
					],
				},
			},
			'мелкий': {
				'щенки': {
					food: {
						30: 'от 14 до 204 граммов корма в день.',
						33: 'от 14 до 204 граммов корма в день.',
						51: 'от 4,5 до 6 упаковок в день.',
					},
					actions: [
						'ball',
						'rope',
					],
				},
				'взрослые': {
					food: {
						35: 'от 25 до 135 граммов корма в день.',
						52: 'от 3 до 6 упаковок в день.',
						53: 'от 3 до 6 упаковок в день.',
						54: 'от 3 до 6 упаковок в день.',
						38: 'от 25 до 135 граммов корма в день.',
					},
					actions: [
						'walk-active',
						'training-pick',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 135 граммов корма в день.',
						52: 'от 4 до 5 упаковок в день.',
						53: 'от 4 до 5 упаковок в день.',
						54: 'от 4 до 5 упаковок в день.',
					},
					actions: [
						'walk-active',
						'training-trick',
					],
				},
			},
			'средний': {
				'щенки': {
					food: {
						31: 'от 80 до 374 граммов корма в день.',
						33: 'от 80 до 374 граммов корма в день.',
						51: 'от 7 до 9 упаковок в день.',
					},
					actions: [
						'ball',
						'frisbee',
					],
				},
				'взрослые': {
					food: {
						36: 'от 140 до 275 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',
						38: 'от 140 до 275 граммов корма в день.',
					},
					actions: [
						'velo',
						'training-discipline',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 152 до 250 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',
					},
					actions: [
						'walk-active',
						'search-toy',
					],
				},
			},
			'крупный': {
				'щенки': {
					food: {
						32: 'от 310 до 525 граммов корма в день.',
						33: 'от 310 до 525 граммов корма в день.',
						51: 'от 13 до 20 упаковок в день.',
					},
					actions: [
						'training-basic',
						'ball',
					],
				},
				'взрослые': {
					food: {
						37: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',
					},
					actions: [
						'training-trick',
						'rope',
					],
				},
				'от 6 лет и выше': {
					food: {
						44: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',						
					},
					actions: [
						'search-food',
						'ball',
					],
				},
			},
		},
	},
	'склонное к полноте': {
		'до 20 мин.': {
			'миниатюрный': {
				'щенки': {
					food: {
						29: 'от 15 до 113 граммов корма в день.',
						33: 'от 15 до 113 граммов корма в день.',
						51: 'от 2 до 3 упаковок в день.',
					},
					actions: [
						'rope',
						'ball',
					],
				},
				'взрослые': {
					food: {
						34: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 5 упаковок в день.',
						53: 'от 2 до 5 упаковок в день.',
						54: 'от 2 до 5 упаковок в день.',
						38: 'от 2 до 5 упаковок в день.',
					},
					actions: [
						'ball',
						'training-stranger',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 3 упаковок в день.',
						53: 'от 2 до 3 упаковок в день.',
						54: 'от 2 до 3 упаковок в день.',
					},
					actions: [
						'search-toy',
						'toy-soft-small',
					],
				},
			},
			'мелкий': {
				'щенки': {
					food: {
						30: 'от 14 до 204 граммов корма в день.',
						33: 'от 14 до 204 граммов корма в день.',
						51: 'от 4,5 до 6 упаковок в день.',
					},
					actions: [
						'ball',
						'training-aport',
					],
				},
				'взрослые': {
					food: {
						35: 'от 25 до 135 граммов корма в день.',
						52: 'от 3 до 6 упаковок в день.',
						53: 'от 3 до 6 упаковок в день.',
						54: 'от 3 до 6 упаковок в день.',
						38: 'от 25 до 135 граммов корма в день.',
					},
					actions: [
						'walk-active',
						'rope',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 135 граммов корма в день.',
						52: 'от 4 до 5 упаковок в день.',
						53: 'от 4 до 5 упаковок в день.',
						54: 'от 4 до 5 упаковок в день.',
					},
					actions: [
						'search-food',
						'walk-quiet',
					],
				},
			},
			'средний': {
				'щенки': {
					food: {
						31: 'от 80 до 374 граммов корма в день.',
						33: 'от 80 до 374 граммов корма в день.',
						51: 'от 7 до 9 упаковок в день.',
					},
					actions: [
						'frisbee',
						'toy-heavy',
					],
				},
				'взрослые': {
					food: {
						36: 'от 140 до 275 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',
						38: 'от 140 до 275 граммов корма в день.',
					},
					actions: [
						'training-basic',
						'ball',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 152 до 250 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',		
					},
					actions: [
						'toy-soft',
						'search-toy',
					],
				},
			},
			'крупный': {
				'щенки': {
					food: {
						32: 'от 310 до 525 граммов корма в день.',
						33: 'от 310 до 525 граммов корма в день.',
						51: 'от 13 до 20 упаковок в день.',
					},
					actions: [
						'rope',
						'training-basic',
					],
				},
				'взрослые': {
					food: {
						37: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',					
					},
					actions: [
						'catch-up',
						'training-trick',
					],
				},
				'от 6 лет и выше': {
					food: {
						44: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',						
					},
					actions: [
						'ball',
						'rope',
					],
				},
			},
		},
		'20-40 мин.': {
			'миниатюрный': {
				'щенки': {
					food: {
						29: 'от 15 до 113 граммов корма в день.',
						33: 'от 15 до 113 граммов корма в день.',
						51: 'от 2 до 3 упаковок в день.',
					},
					actions: [
						'ball',
						'search-food',
					],
				},
				'взрослые': {
					food: {
						34: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 5 упаковок в день.',
						53: 'от 2 до 5 упаковок в день.',
						54: 'от 2 до 5 упаковок в день.',
						38: 'от 25 до 80 граммов корма в день.',					
					},
					actions: [
						'toy-squeaky',
						'training-pick',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 3 упаковок в день.',
						53: 'от 2 до 3 упаковок в день.',
						54: 'от 2 до 3 упаковок в день.',						
					},
					actions: [
						'walk-quiet',
						'search-owner',
					],
				},
			},
			'мелкий': {
				'щенки': {
					food: {
						30: 'от 14 до 204 граммов корма в день.',
						33: 'от 14 до 204 граммов корма в день.',
						51: 'от 4,5 до 6 упаковок в день.',
					},
					actions: [
						'ball',
						'toy-squeaky',
					],
				},
				'взрослые': {
					food: {
						35: 'от 25 до 135 граммов корма в день.',
						52: 'от 3 до 6 упаковок в день.',
						53: 'от 3 до 6 упаковок в день.',
						54: 'от 3 до 6 упаковок в день.',
						38: 'от 25 до 135 граммов корма в день.',					
					},
					actions: [
						'run-usual',
						'training-trick',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 135 граммов корма в день.',
						52: 'от 4 до 5 упаковок в день.',
						53: 'от 4 до 5 упаковок в день.',
						54: 'от 4 до 5 упаковок в день.',						
					},
					actions: [
						'walk-quiet',
						'ball',
					],
				},
			},
			'средний': {
				'щенки': {
					food: {
						31: 'от 80 до 374 граммов корма в день.',
						33: 'от 80 до 374 граммов корма в день.',
						51: 'от 7 до 9 упаковок в день.',
					},
					actions: [
						'training-basic',
						'frisbee',
					],
				},
				'взрослые': {
					food: {
						36: 'от 140 до 275 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',
						38: 'от 140 до 275 граммов корма в день.',					
					},
					actions: [
						'rope',
						'catch-up',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 152 до 250 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',						
					},
					actions: [
						'search-toy',
						'walk-quiet',
					],
				},
			},
			'крупный': {
				'щенки': {
					food: {
						32: 'от 310 до 525 граммов корма в день.',
						33: 'от 310 до 525 граммов корма в день.',
						51: 'от 13 до 20 упаковок в день.',
					},
					actions: [
						'rope',
						'training-basic',
					],
				},
				'взрослые': {
					food: {
						37: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',					
					},
					actions: [
						'training-trick',
						'rope',
					],
				},
				'от 6 лет и выше': {
					food: {
						44: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',						
					},
					actions: [
						'walk-quiet',
						'toy-soft',
					],
				},
			},
		},
		'40 мин. и более': {
			'миниатюрный': {
				'щенки': {
					food: {
						29: 'от 15 до 113 граммов корма в день.',
						33: 'от 15 до 113 граммов корма в день.',
						51: 'от 2 до 3 упаковок в день.',
					},
					actions: [
						'ball',
						'toy-soft-puppy',
					],
				},
				'взрослые': {
					food: {
						34: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 5 упаковок в день.',
						53: 'от 2 до 5 упаковок в день.',
						54: 'от 2 до 5 упаковок в день.',
						38: 'от 25 до 80 граммов корма в день.',					
					},
					actions: [
						'walk-active',
						'rope',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 80 граммов корма в день.',
						52: 'от 2 до 3 упаковок в день.',
						53: 'от 2 до 3 упаковок в день.',
						54: 'от 2 до 3 упаковок в день.',						
					},
					actions: [
						'search-owner',
						'walk-quiet',
					],
				},
			},
			'мелкий': {
				'щенки': {
					food: {
						30: 'от 14 до 204 граммов корма в день.',
						33: 'от 14 до 204 граммов корма в день.',
						51: 'от 4,5 до 6 упаковок в день.',
					},
					actions: [
						'toy-squeaky',
						'ball',
					],
				},
				'взрослые': {
					food: {
						35: 'от 25 до 135 граммов корма в день.',
						52: 'от 3 до 6 упаковок в день.',
						53: 'от 3 до 6 упаковок в день.',
						54: 'от 3 до 6 упаковок в день.',
						38: 'от 25 до 135 граммов корма в день.',
					},
					actions: [
						'training-trick',
						'training-pick',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 25 до 135 граммов корма в день.',
						52: 'от 4 до 5 упаковок в день.',
						53: 'от 4 до 5 упаковок в день.',
						54: 'от 4 до 5 упаковок в день.',						
					},
					actions: [
						'walk-quiet',
						'search-toy',
					],
				},
			},
			'средний': {
				'щенки': {
					food: {
						31: 'от 80 до 374 граммов корма в день.',
						33: 'от 80 до 374 граммов корма в день.',
						51: 'от 7 до 9 упаковок в день.',
					},
					actions: [
						'rope',
						'training-basic',
					],
				},
				'взрослые': {
					food: {
						36: 'от 140 до 275 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',
						38: 'от 140 до 275 граммов корма в день.',						
					},
					actions: [
						'frisbee',
						'walk-active',
					],
				},
				'от 6 лет и выше': {
					food: {
						45: 'от 152 до 250 граммов корма в день.',
						52: 'от 7 до 8 упаковок в день.',
						53: 'от 7 до 8 упаковок в день.',
						54: 'от 7 до 8 упаковок в день.',
					},
					actions: [
						'walk-quiet',
						'search-toy',
					],
				},
			},
			'крупный': {
				'щенки': {
					food: {
						32: 'от 310 до 525 граммов корма в день.',
						33: 'от 310 до 525 граммов корма в день.',
						51: 'от 13 до 20 упаковок в день.',
					},
					actions: [
						'training-basic',
						'rope',
					],
				},
				'взрослые': {
					food: {
						37: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',					
					},
					actions: [
						'rope',
						'run-usual',
					],
				},
				'от 6 лет и выше': {
					food: {
						44: 'от 281 до 799 граммов корма в день.',
						52: 'от 8 до 10 упаковок в день.',
						53: 'от 8 до 10 упаковок в день.',
						54: 'от 8 до 10 упаковок в день.',
						38: 'от 281 до 799 граммов корма в день.',						
					},
					actions: [
						'walk-quiet',
						'search-owner',
					],
				},
			},
		},
	},
}



// WEBPACK FOOTER //
// ./src/data/dog.js